import React from 'react';
import { Link } from 'react-router-dom';

export default function Diensten() {
  const services = [
    {
      icon: 'fa-stethoscope',
      title: 'Psychiatrische consultatie',
      description: 'Deskundige diagnostiek en behandeladvies voor complexe casuïstiek binnen uw instelling. Ondersteuning bij diagnostische vraagstukken en second opinions.'
    },
    {
      icon: 'fa-clipboard-check',
      title: 'Regiebehandelaarschap',
      description: 'Eindverantwoordelijke rol binnen behandeltrajecten volgens de geldende kwaliteitsnormen. Inclusief indicatiestelling en evaluatie van behandelplannen.'
    },
    {
      icon: 'fa-users',
      title: 'Psychiatrische spreekuren',
      description: 'Intakes, diagnostiek en medicatiebeleid. Reguliere spreekuren voor uw cliënten met psychiatrische ondersteuningsbehoefte.'
    },
    {
      icon: 'fa-brain',
      title: 'Medicatiebeleid',
      description: 'Advisering en begeleiding bij farmacotherapie. Evaluatie van huidige medicatie en optimalisatie van behandelschema\'s.'
    },
    {
      icon: 'fa-comments',
      title: 'Intercollegiale consultatie',
      description: 'Ondersteuning van uw behandelteam met psychiatrische expertise. Casus-besprekingen en advies bij complexe problematiek.'
    },
    {
      icon: 'fa-wine-bottle',
      title: 'Verslavingszorg',
      description: 'Gespecialiseerde expertise in poliklinische én klinische verslavingszorg. Integrale aanpak van verslaving en comorbide psychiatrische stoornissen.'
    },
  ];

  return (
    <>
      {/* Page Hero */}
      <section className="bg-[#2d5e5e] pt-32 pb-16 text-center text-white">
        <div className="max-w-6xl mx-auto px-5">
          <h1 className="text-3xl font-bold mb-3">Onze diensten</h1>
          <p className="text-lg opacity-90">Wat wij voor uw instelling kunnen betekenen</p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-24 bg-white">
        <div className="max-w-6xl mx-auto px-5">
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-gray-100 rounded-xl p-10 text-center border-2 border-transparent hover:bg-white hover:border-[#a4cc3a] hover:-translate-y-1 hover:shadow-lg transition-all group"
              >
                <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-5 shadow-md group-hover:bg-[#2d5e5e] transition-all">
                  <i className={`fas ${service.icon} text-2xl text-[#2d5e5e] group-hover:text-white transition-colors`}></i>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{service.description}</p>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="bg-gray-100 rounded-2xl p-12 text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-3">Interesse in onze diensten?</h3>
            <p className="text-gray-600 mb-6">Vraag direct een offerte aan met onze calculator.</p>
            <Link to="/offerte" className="btn-primary">
              Offerte aanvragen
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
